// **BEGIN** Hextom TMS Integration - DO NOT MODIFY
      var hextom_tms = {
        selectorInsertType:  "insert",
        regionType:  "region_name_currency_symbol",
        availableLocalesById: {},
        availableLocales: [],
        primaryLocaleById: {},
        merchantSelectedLocale: "shop_base",
        hasFlag: "yes",
        selectorFlagMap: {'en': 'en', 'fi': 'fi', 'ar': 'ar'},
        displayType: "language_code",
        fontColor: "#020912",
        backgroundColor: "#c8c8c8",
        backgroundOpacity: "1.0",
        buttonFontColor: "#FFFFFF",
        buttonBackgroundColor: "#000000",
        selectorType: "market_language",
        selectorStyle: "dropdown",
        hasFlagRegion: "yes",
        defaultRegion: "ip_base",
        primaryRegionById: {},
        availableRegionsByCode: {},
        availableRegions: [],
        primaryDomain: "",
        popupEnable: false,
        popupTextColor: "#000000",
        popupBgColor: "#FFFFFF",
        popupBtnTextColor: "#FFFFFF",
        popupBtnBgColor: "#000000",
        regions: [{"name": "Finland", "code": "FI", "currency": {"code": "EUR", "symbol": "\u20ac"}, "languages": {"English": {"name": "English", "native_name": "English", "code": "en", "default": true}, "Suomi": {"name": "Suomi (Finnish)", "native_name": "Suomi", "code": "fi", "default": false}, "\u0639\u0631\u0628\u064a": {"name": "\u0639\u0631\u0628\u064a(Arabic)", "native_name": "\u0639\u0631\u0628\u064a", "code": "ar", "default": false}}, "primary": true}],
      };
    // **END** Hextom TMS Integration - DO NOT MODIFY
        